module.exports = __webpack_public_path__ + "img/systems.5f188ca4.svg";